import { OCCUPATIONS, QUALIFICATIONS, INCOME_SLABS } from "../wizardUtils";

export default function ProposerContact({ state, setState, errors }) {
  const set = (field, value) =>
    setState((s) => ({ ...s, proposer: { ...s.proposer, [field]: value } }));

  return (
    <div data-testid="wizard-step-proposer">
      <h2 className="text-3xl sm:text-4xl font-medium tracking-tight mb-2">
        Proposer details
      </h2>
      <p className="text-secondary-brand mb-8 leading-relaxed">
        The proposer is the person buying the policy and paying the premium.
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
        <div className="sm:col-span-2">
          <label className="form-label" htmlFor="proposerName">
            Proposer Name
          </label>
          <input
            id="proposerName"
            type="text"
            value={state.proposer.name}
            onChange={(e) => set("name", e.target.value)}
            className={`form-input ${errors.name ? "error" : ""}`}
            placeholder="e.g. Aditi Sharma"
            data-testid="input-proposer-name"
          />
          {errors.name && (
            <p className="error-text" data-testid="error-proposer-name">
              {errors.name}
            </p>
          )}
        </div>

        <div>
          <label className="form-label" htmlFor="proposerMobile">
            Mobile Number
          </label>
          <input
            id="proposerMobile"
            type="tel"
            inputMode="numeric"
            maxLength={10}
            value={state.proposer.mobile}
            onChange={(e) =>
              set("mobile", e.target.value.replace(/\D/g, "").slice(0, 10))
            }
            className={`form-input ${errors.mobile ? "error" : ""}`}
            placeholder="10-digit mobile"
            data-testid="input-proposer-mobile"
          />
          {errors.mobile && (
            <p className="error-text" data-testid="error-proposer-mobile">
              {errors.mobile}
            </p>
          )}
        </div>

        <div>
          <label className="form-label" htmlFor="proposerAltMobile">
            Alternate Mobile (optional)
          </label>
          <input
            id="proposerAltMobile"
            type="tel"
            inputMode="numeric"
            maxLength={10}
            value={state.proposer.alternateMobile}
            onChange={(e) =>
              set("alternateMobile", e.target.value.replace(/\D/g, "").slice(0, 10))
            }
            className={`form-input ${errors.alternateMobile ? "error" : ""}`}
            placeholder="10-digit mobile"
            data-testid="input-proposer-altmobile"
          />
          {errors.alternateMobile && (
            <p className="error-text" data-testid="error-proposer-altmobile">
              {errors.alternateMobile}
            </p>
          )}
        </div>

        <div className="sm:col-span-2">
          <label className="form-label" htmlFor="proposerEmail">
            Email ID
          </label>
          <input
            id="proposerEmail"
            type="email"
            value={state.proposer.email}
            onChange={(e) => set("email", e.target.value)}
            className={`form-input ${errors.email ? "error" : ""}`}
            placeholder="you@example.com"
            data-testid="input-proposer-email"
          />
          {errors.email && (
            <p className="error-text" data-testid="error-proposer-email">
              {errors.email}
            </p>
          )}
        </div>

        <div className="sm:col-span-2">
          <label className="form-label" htmlFor="proposerAddress">
            Permanent Address
          </label>
          <textarea
            id="proposerAddress"
            rows={3}
            value={state.proposer.address}
            onChange={(e) => set("address", e.target.value)}
            className={`form-input py-3 ${errors.address ? "error" : ""}`}
            style={{ height: "auto" }}
            placeholder="Flat / House No, Street, Area, Landmark"
            data-testid="input-proposer-address"
          />
          {errors.address && (
            <p className="error-text" data-testid="error-proposer-address">
              {errors.address}
            </p>
          )}
        </div>

        <div>
          <label className="form-label" htmlFor="proposerCity">
            City (optional)
          </label>
          <input
            id="proposerCity"
            type="text"
            value={state.proposer.city}
            onChange={(e) => set("city", e.target.value)}
            className="form-input"
            placeholder="e.g. Mumbai"
            data-testid="input-proposer-city"
          />
        </div>

        <div>
          <label className="form-label" htmlFor="proposerPin">
            PIN Code
          </label>
          <input
            id="proposerPin"
            type="text"
            inputMode="numeric"
            maxLength={6}
            value={state.proposer.pincode}
            onChange={(e) =>
              set("pincode", e.target.value.replace(/\D/g, "").slice(0, 6))
            }
            className={`form-input ${errors.pincode ? "error" : ""}`}
            placeholder="e.g. 400001"
            data-testid="input-proposer-pincode"
          />
          {errors.pincode && (
            <p className="error-text" data-testid="error-proposer-pincode">
              {errors.pincode}
            </p>
          )}
        </div>

        <div>
          <label className="form-label" htmlFor="proposerOcc">
            Occupation
          </label>
          <select
            id="proposerOcc"
            value={state.proposer.occupation}
            onChange={(e) => set("occupation", e.target.value)}
            className={`form-input ${errors.occupation ? "error" : ""}`}
            data-testid="select-proposer-occupation"
          >
            <option value="">Select occupation…</option>
            {OCCUPATIONS.map((o) => (
              <option key={o} value={o}>
                {o}
              </option>
            ))}
          </select>
          {errors.occupation && (
            <p className="error-text" data-testid="error-proposer-occupation">
              {errors.occupation}
            </p>
          )}
        </div>

        <div>
          <label className="form-label" htmlFor="proposerQual">
            Qualification
          </label>
          <select
            id="proposerQual"
            value={state.proposer.qualification}
            onChange={(e) => set("qualification", e.target.value)}
            className={`form-input ${errors.qualification ? "error" : ""}`}
            data-testid="select-proposer-qualification"
          >
            <option value="">Select qualification…</option>
            {QUALIFICATIONS.map((q) => (
              <option key={q} value={q}>
                {q}
              </option>
            ))}
          </select>
          {errors.qualification && (
            <p className="error-text" data-testid="error-proposer-qualification">
              {errors.qualification}
            </p>
          )}
        </div>

        <div className="sm:col-span-2">
          <label className="form-label" htmlFor="proposerIncome">
            Annual Income
          </label>
          <select
            id="proposerIncome"
            value={state.proposer.annualIncome}
            onChange={(e) => set("annualIncome", e.target.value)}
            className={`form-input ${errors.annualIncome ? "error" : ""}`}
            data-testid="select-proposer-income"
          >
            <option value="">Select annual income…</option>
            {INCOME_SLABS.map((s) => (
              <option key={s} value={s}>
                {s}
              </option>
            ))}
          </select>
          {errors.annualIncome && (
            <p className="error-text" data-testid="error-proposer-income">
              {errors.annualIncome}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
